$(function() {
	if ((!$body.hasClass('page-template-page-holiday')))
		return;

	let loadedCount = 0;
	let holidayListing = $('.posts.holiday_listing');
	let events = holidayListing.find('.holiday_container');
	let categories = $('#events_categories');
	let specials, location, requestUrl;
	var link = window.location.pathname
	let currentCategory = window.location.href.match(/#([^/&]+)/);


	function eventsFilter() {
		var myul = $('.myul');
		var lis = myul.find('li');
		var dropdown = $('.show');
		var lower = $('.lower');
		lis.on('click', function(e) {
			dropdown.toggleClass('flip');
			if (myul.hasClass('active')) {
				myul.removeClass('active');
			}
			else {
				myul.addClass('active');
			}
			lis.removeClass('active');
			$(e.target).parent().addClass('active');
		});
	}

	var monthHeadings = {};
	$('.holiday_month').each(function() {
		var text = $(this).text();
		if (monthHeadings[text])
			$(this).remove();
		else
			monthHeadings[text] = true;
	});



	// $window.trigger('resize');
	// var categories = $('.category_link');
	// var activeCategory = 'all';
	// var filteredEvents = events;

	// $(window).on('hashchange', function(e){
	// 	var currentUrl = URI(document.location);
	// 	if (currentUrl.hash()) {
	// 		var currentlySelected = categories.filter('[href="' + currentUrl.hash() + '"]');
	// 		if (currentlySelected.length) {
	// 			currentlySelected.trigger('click')
	// 		} else {
	// 			categories.eq(0).trigger('click');
	// 		}
	// 	} else {
	// 		categories.eq(0).trigger('click');
	// 	}
	// });

	$('#filter_mobile_button').click(function(){
		$('#events_categories nav').toggleClass('open');
	});

	// var updateUrl = function(url) {
	// 	if (url != window.location.href)
	// 		window.history.pushState('', '', url);
	// 	// update active link in main nav
	// 	$('#main_menu').find('a[href="' + url + '"]').parent().siblings().removeClass('current-menu-item');
	// 	$('#main_menu').find('a[href="' + url + '"]').parent().addClass('current-menu-item');
	// }

	// var filterCategory = function(element) {
	// 	element.removeClass('appear');
	// 	element.siblings('.holiday_month').removeClass('appear');


	// 	if (element) {
	// 		activeCategory = element.attr('href').slice(1);
	// 	}

	// 	element.hide();
	// 	element.siblings('.holiday_month').hide();

	// 	if (activeCategory == 'all') {
	// 		filteredEvents = element;
	// 	} else {
	// 		filteredEvents = element.filter('[cat*=' + activeCategory + ']');
	// 	}

	// 	// displayEvents(filteredEvents);

	// 	var url = window.location.href;
	// 	if(url.indexOf("utm") > -1) {
	// 	var utmURL = document.location.href;
	// 		updateUrl(utmURL.substring(0, utmURL.indexOf('#')) + '#' + activeCategory);
	// 	}
	// 	else {
	// 		updateUrl(document.location.origin + document.location.pathname + '#' + activeCategory);
	// 	}
	// }

	

	categories.find('.category_link').click(function(e) {
		e.preventDefault()
		var cat = $(this).data('category')
		$('.category_link').removeClass('active_category');
		$(this).addClass('active_category');

		holidayListing.find('.holiday_container').each(function() {
			if(!cat || $(this).attr('cat') == cat ) {
				$(this).addClass('appear')
				
			} else {
				$(this).removeClass('appear')
			
			}

			if(cat) {
				history.pushState({}, '', link + "#" + cat);
			} else {
				history.pushState({}, '', link);
			}

			
		})
	});

	// if (!categories.length)
	// 	displayEvents(events);

	// Activate the proper category and image on page load
	// var currentUrl = URI(document.location);
	// if (currentUrl.hash()) {
	// 	var currentlySelected = categories.filter('[href="' + currentUrl.hash() + '"]');
	// 	if (currentlySelected.length) {
	// 		currentlySelected.trigger('click')
	// 	} else {
	// 		categories.eq(0).trigger('click');
	// 	}
	// } else {
	// 	categories.eq(0).trigger('click');
	// }

	eventsFilter();
	$('document').ready(function() {

		holidayListing.addClass('ready')

		if(currentCategory) {
			displayEvents(currentCategory)
			$('.category_link').removeClass('active_category');
			categories.find('.category_link').each(function() {
				if(currentCategory[1] == $(this).data('category')) {
						$(this).parent().addClass('active');
						$(this).addClass('active_category');
					} else {
						$(this).parent().removeClass('active');
						$(this).removeClass('active_category');
					}
			})

		} else {
			displayEvents(currentCategory)
			categories.find('.category_link').each(function() {
				let href = $(this).attr('href')
				if(href == link) {
						$(this).parent().addClass('active');
						$(this).addClass('active_category');
					} 
			})
		}
		
	})

	let displayEvents = function(category) {

		$.get('/api/geolocate', function(response) {
			location = response
			console.log('location',location.state)
	
			if(location.state == "HI") {
				requestUrl = '/get_hawaii_holidays'
			} else {
				requestUrl = '/get_outside_hawaii_holidays'
			}
			
	
			$.get(requestUrl, function(response) {
				response = $.parseJSON(response);
				specials = response;
				
				holidayListing.html(specials.holidays);
				
				if(!category) {
					category
					
				}  else {
					category = category[1]
				}

				holidayListing.find('.holiday_container').each(function() {

					let post = $(this)
					if(!category ||  post.attr('cat') == category ) {
						// console.log('true',$(this).attr('cat'))
						post.addClass('appear')
					} else {
						post.removeClass('appear')
						// console.log('false',$(this).attr('cat'))
					}

					// categories.find('.category_link').each(function() {
					// 	if($(this).data('category') && post.attr('cat') != $(this).data('category') ) {
					// 		console.log(post)
					// 		$(this).parent().addClass('disable')
					// 	} else {
					// 		$(this).parent().removeClass('disable')
					// 	}
	
					
					// })
				})

				

				// console.log(filteredEvents)
				// filterCategory(filteredEvents);
				// filteredEvents.show();
				// filteredEvents.siblings('.holiday_month').show();

				// setTimeout(function() {
				// 	filteredEvents.addClass('appear');
				// 	filteredEvents.siblings('.holiday_month').addClass('appear');
				// }, 50);
	
			});
		});
		
	}


	

	

});